<template>
  <v-row>
    <customer-list v-if="userData.role === 'PLSYR' && $vuetify.breakpoint.xsOnly" />
    <v-col cols="12" :class="status ? 'px-3 px-lg-3' : null">
      <div v-if="appStore.hasOverdueMutabakat" class="px-3">
        <mutabakat-order-blocked-alert />
      </div>
      <div v-else-if="status" id="order-list">

        <order-content class="px-3" @changeStatus="pageLoadingStatus"></order-content>

      </div>
      <div v-else>

        <v-alert
          text
          outlined
          class="mx-3 mx-lg-0 rounded-pill mt-2 mt-md-0 text-caption"
          type="warning"
        >
          Lütfen yukarıdan bir müşteri seçin
        </v-alert>
      </div>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import CustomerList from "@/components/CustomerList.vue";
import store from "@/store";
import orderStoreModule from "@/views/order/orderStoreModule";
import useAppConfig from "@core/@app-config/useAppConfig";
import { useRouter } from "@core/utils";
import {
  mdiAccount,
  mdiEye,
  mdiFileExcel,
  mdiFilter,
  mdiFilterOff,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiMagnify,
  mdiMessage,
  mdiPencil,
  mdiPlus,
  mdiPrinter,
  mdiSend,
  mdiShare,
  mdiShield,
  mdiShieldHalfFull,
  mdiSquareEditOutline,
  mdiWeatherNight,
  mdiWeatherSunny,
} from "@mdi/js";
import { onMounted, ref, watch } from "@vue/composition-api";
import { useAppStore } from "@/stores/app";
import OrderContent from "./order-components/OrderContent.vue";
import MutabakatOrderBlockedAlert from "@/components/MutabakatOrderBlockedAlert.vue";


export default {
  components: {

    OrderContent,

    CustomerList,
    MutabakatOrderBlockedAlert,
  },
  setup() {
    const { isDark } = useAppConfig();
    const { route } = useRouter();
    const appStore = useAppStore();
    const userData = JSON.parse(localStorage.getItem("userData"));
    const status = ref(false);
    const pageLoading = ref(true);
    const isAddNewUserSidebarActive = ref(false);

    const PRODUCT_APP_STORE_MODULE_NAME = "app-order";

    const updateCustomerLimit = () => {
      if (!localStorage.getItem("accessToken")) return;
      store.dispatch("syncCustomerLimit", { callTo: "ordering" });
    };

    // Register module
    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME)) {
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, orderStoreModule);
    }
    onMounted(() => {
      updateCustomerLimit();
      if (userData.role === "COMMAN" && store.state.plasiyerCustomer === null) {
        status.value = false;
      } else if (userData.role === "CUST" || userData.role === "BAYI" || userData.role === "SUBE") {
        status.value = true;
      } else {
        status.value = true;
      }
    });

    const pageLoadingStatus = () => {
      pageLoading.value = false;
    };
    watch(
      () => store.state.plasiyerCustomer,
      (newVal, oldVal) => {
        if (userData.role === "COMMAN") {
          if (typeof store.state.plasiyerCustomer === "undefined") {
            status.value = false;
          }
        }

        if (store.state.plasiyerCustomer) {
          status.value = true;
        }

        if (oldVal !== undefined && newVal !== oldVal && newVal) {
          updateCustomerLimit();
        }
      }
    );

    watch(
      () => route.value.params.type,
      () => {
        updateCustomerLimit();
      }
    );

    return {
      isDark,
      isAddNewUserSidebarActive,
      status,
      pageLoading,
      pageLoadingStatus,
      userData,
      appStore,

      // icons
      icons: {
        mdiFileExcel,
        mdiMessage,
        mdiWeatherNight,
        mdiWeatherSunny,
        mdiSquareEditOutline,
        mdiPencil,
        mdiPrinter,
        mdiAccount,
        mdiPlus,
        mdiEye,
        mdiMagnify,
        mdiShare,
        mdiFilter,
        mdiFullscreen,
        mdiFullscreenExit,
        mdiShield,
        mdiSend,
        mdiShieldHalfFull,
        mdiFilterOff,
      },
    };
  },
  data() {
    return {
      date: null,
      modal: false,
      fullscreenStatus: false,
      filterStatus: false,
      dataTableHeight: "",
      height: {
        system: 0,
        top: 87,
        footer: 47,
      },
    };
  },
};
</script>
